import React from 'react';

import colors from '../sl-colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const SolidSortDescending = ({
  color = colors.gray['600'],
  width = 24,
  height = 24,
  ...props
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 14.5C16 14.22 15.78 14 15.5 14H8.5C8.22 14 8 14.22 8 14.5C8 14.63 8.05 14.74 8.13 14.83V14.83L11.63 18.83V18.83C11.72 18.93 11.85 19 12 19C12.15 19 12.28 18.93 12.37 18.83V18.83L15.87 14.83V14.83C15.95 14.74 16 14.63 16 14.5Z"
      fill={color}
    />
    <path
      opacity="0.24"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 9.5C8 9.78 8.22 10 8.5 10L15.5 10C15.78 10 16 9.78 16 9.5C16 9.37 15.95 9.26 15.87 9.17V9.17L12.37 5.17V5.17C12.28 5.07 12.15 5 12 5C11.85 5 11.72 5.07 11.63 5.17V5.17L8.13 9.17V9.17C8.05 9.26 8 9.37 8 9.5Z"
      fill={color}
    />
  </svg>
);

export default SolidSortDescending;
